var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlyplayLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 156,
    height: 36,
    viewBox: "20 50 428 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D1C1D;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000179613112158375959770000011240996540891759785_);}\n\t.st4{fill:url(#SVGID_00000181790314484141975940000004476573952190966462_);}\n\t.st5{fill:url(#SVGID_00000153678914758884134500000006689399985501436554_);}\n\t.st6{fill:url(#SVGID_00000067194182875433142200000017204071389154465935_);}\n\t.st7{fill:url(#SVGID_00000181074586460436531660000001427169501248703624_);}\n\t.st8{fill:url(#SVGID_00000013881775293161320480000001858153476293055404_);}\n\t.st9{fill:url(#SVGID_00000003797297804310156150000003516923379320915629_);}\n\t.st10{fill:url(#SVGID_00000055687676262352442460000003831210853594472846_);}\n\t.st11{fill:url(#SVGID_00000009554430461359415410000005623370424006454916_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 144.6208,
    y1: 38.8569,
    x2: 144.6208,
    y2: 90.3161
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M170.5,64.6c0-15.1-11.4-25.7-25.8-25.7c-14.3,0-25.9,10.6-25.9,25.7s11.6,25.8,25.9,25.8 C159,90.3,170.5,79.7,170.5,64.6z M131.3,64.6c0-8.9,5.2-14.6,13.4-14.6c8,0,13.3,5.7,13.3,14.6c0,8.8-5.2,14.6-13.3,14.6 C136.5,79.2,131.3,73.4,131.3,64.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157286847675021784820000002478419189916259741_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.5078,
    y1: 49.4493,
    x2: 196.5078,
    y2: 89.8151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157286847675021784820000002478419189916259741_)"
    },
    d: "M204.2,89.8h12.2V66.5 c0-10.7-6.2-17-15.4-17c-5.4,0-9.7,2.4-12.1,5.7v-5.3h-12.3v39.9h12.3V68.1c0-5.4,3-8.4,7.7-8.4c4.7,0,7.7,3,7.7,8.4V89.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028299680824060093450000012928161823144695463_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.3868,
    y1: 36.8529,
    x2: 230.3868,
    y2: 89.8151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2624,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028299680824060093450000012928161823144695463_)"
    },
    d: "M224.2,89.8h12.3v-53h-12.3V89.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104707726409380489250000006917964352094572982_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.9073,
    y1: 49.8787,
    x2: 262.9073,
    y2: 108.7813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6512,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104707726409380489250000006917964352094572982_)"
    },
    d: "M263.2,74.9l-9.3-25h-13.7l16.3,38.6 l-9.2,20.3h13.2l25.1-58.9h-13.3L263.2,74.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140692543286270383030000013319964895260888720_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.5008,
    y1: 49.3062,
    x2: 310.5008,
    y2: 108.8529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6948,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140692543286270383030000013319964895260888720_)"
    },
    d: "M301.6,55.5v-5.7h-12.3v59h12.3V84.2 c2.2,3.4,6.5,6.2,12.3,6.2c9.8,0,17.7-8,17.7-20.6c0-12.6-7.8-20.5-17.7-20.5C308.1,49.3,303.9,52,301.6,55.5z M319.2,69.8 c0,6.4-4.2,9.9-8.8,9.9c-4.6,0-8.8-3.5-8.8-9.9c0-6.4,4.2-9.9,8.8-9.9C315,60,319.2,63.4,319.2,69.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171708572160941903890000013505010898546059956_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5098,
    y1: 36.8529,
    x2: 343.5098,
    y2: 89.8151
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2427,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171708572160941903890000013505010898546059956_)"
    },
    d: "M337.4,89.8h12.3v-53h-12.3V89.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178172355800165516270000007771541973908990102_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.5338,
    y1: 49.3062,
    x2: 376.5338,
    y2: 90.3877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178172355800165516270000007771541973908990102_)"
    },
    d: "M355.4,69.8c0,12.6,7.8,20.6,17.6,20.6 c6,0,10.2-2.7,12.4-6.2v5.7h12.3V49.9h-12.3v5.7c-2.2-3.5-6.4-6.2-12.4-6.2C363.2,49.3,355.4,57.2,355.4,69.8z M385.4,69.8 c0,6.4-4.1,9.9-8.8,9.9c-4.6,0-8.8-3.6-8.8-9.9s4.2-9.8,8.8-9.8C381.3,60,385.4,63.5,385.4,69.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111914083677286843100000004704264897271554187_",
    gradientUnits: "userSpaceOnUse",
    x1: 424.0463,
    y1: 49.8787,
    x2: 424.0463,
    y2: 108.7813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6518,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111914083677286843100000004704264897271554187_)"
    },
    d: "M424.3,74.9l-9.3-25h-13.7l16.3,38.6 l-9.2,20.3h13.2l25.1-58.9h-13.3L424.3,74.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026163545257621406860000003189039936986098329_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3948,
    y1: 114.2988,
    x2: 60.3948,
    y2: 39.2983,
    gradientTransform: "matrix(1 0 0 -1 0 140.9308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026163545257621406860000003189039936986098329_)"
    },
    d: "M60.4,101.6c-20.7,0-37.5-16.8-37.5-37.5 c0-20.7,16.8-37.5,37.5-37.5s37.5,16.8,37.5,37.5C97.9,84.8,81.1,101.6,60.4,101.6z M60.4,36.6c-15.2,0-27.5,12.3-27.5,27.5 s12.3,27.5,27.5,27.5s27.5-12.3,27.5-27.5S75.6,36.6,60.4,36.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127754050502283488670000008782752457505152928_",
    gradientUnits: "userSpaceOnUse",
    x1: 60.3948,
    y1: 89.2986,
    x2: 60.3948,
    y2: 64.2986,
    gradientTransform: "matrix(1 0 0 -1 0 140.9308)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79F2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4D4D"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000127754050502283488670000008782752457505152928_)"
    },
    cx: 60.4,
    cy: 64.1,
    r: 12.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlyplayLogo);
export default __webpack_public_path__ + "static/media/onlyplay_logo.7c71e766a69e292fe0c2e48aa4707ba5.svg";
export { ForwardRef as ReactComponent };